'use client';
import { jsx as t } from "react/jsx-runtime";
import { useInheritDocDirection as n, cn as o } from "@tameeni/shared-logic";
import { Animated as c } from "@tameeni/ui";
function a({
  children: e,
  className: i
}) {
  const { direction: r } = n();
  return /* @__PURE__ */ t(
    c.SlideIn,
    {
      direction: r === "rtl" ? "right" : "left",
      useScroll: !0,
      transition: { delay: 0.2 },
      children: /* @__PURE__ */ t(
        "h2",
        {
          className: o(
            "text-h4 text-slate-600 text-center mb-8 whitespace-pre-line",
            i
          ),
          children: e
        }
      )
    }
  );
}
export {
  a as SectionSubtitle
};
//# sourceMappingURL=section-subtitle.js.map
